import { useCallback } from 'react';
import PropTypes from 'prop-types';
import toast from 'react-hot-toast';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import { Box, Button, Divider, Popover, SvgIcon, Typography} from '@mui/material';
import { ListItemButton, ListItemIcon, ListItemText} from '@mui/material';

import { RouterLink } from 'src/components/router-link';
import { useAuth, useUser } from 'src/hooks/use-auth';
// import { useMockedUser } from 'src/hooks/use-mocked-user';
import { useRouter } from 'src/hooks/use-router';
import { paths } from 'src/paths';
import { Issuer } from 'src/utils/auth';
// import { useNavigate } from "react-router-dom";
import { showLog, showWarn, showError } from 'src/utils/debug-log';

export const AccountPopover = (props) => {
  const { anchorEl, onClose, open, isTeacher, ...other } = props;
  const router = useRouter();
  const auth = useAuth();
  const user = useUser();
  // const navigate = useNavigate();

  showLog('Popover open:', open);
  // Handle logout
  
  const handleLogout = useCallback(async () => {
    try {
      onClose?.();
      switch (auth.issuer) {
        // case Issuer.Amplify: {
        //   await auth.signOut();
        //   break;
        // }
        // case Issuer.Auth0: {
        //   await auth.logout();
        //   break;
        // }
        // case Issuer.Firebase: {
        //   await auth.signOut();
        //   break;
        // }
        case Issuer.JWT: {
          await auth.signOut();
          break;
        }

        default: {
          showWarn('Using an unknown Auth Issuer, did not log out');
        }
      }
      // router.push(paths.myauth.index);
      // navigate(paths.auth.jwt.login);
    } catch (err) {
      showError(err);
      toast.error('Something went wrong!');
    } finally {
      router.push(paths.myauth.index);

      // This forces going back to the first page in history
      // window.history.go(-window.history.length + 1);
      // setTimeout(() => {
      //   router.push(paths.myauth.index);
      // }, 250); 
    }
  }, [auth, router, onClose]);

  return (
    <Popover
      anchorEl={anchorEl}
      anchorOrigin={{
        horizontal: 'center',
        vertical: 'bottom',
      }}
      disableScrollLock
      onClose={onClose}
      open={!!open}
      PaperProps={{ sx: { width: 280 } }}
      {...other}
    >
      <Box sx={{ p: 2 }}>
        <Typography variant="body1">{user.name}</Typography>
        <Typography color="text.secondary" variant="body2">
          {user.code}
        </Typography>
      </Box>
      <Divider />
      <Box sx={{ p: 1 }}>
        {isTeacher && (
          <ListItemButton
            component={RouterLink}
            to={paths.dashboard.information}
            onClick={onClose}
            sx={{
              borderRadius: 1,
              px: 1,
              py: 0.5,
            }}
          >
            <ListItemIcon>
              <SvgIcon fontSize="small">
                <AccountBalanceWalletOutlinedIcon />
              </SvgIcon>
            </ListItemIcon>
            <ListItemText primary={<Typography variant="body1">Thông tin</Typography>} />
          </ListItemButton>
        )}
        <ListItemButton
          component={RouterLink}
          to={paths.dashboard.account}
          onClick={onClose}
          sx={{
            borderRadius: 1,
            px: 1,
            py: 0.5,
          }}
        >
          <ListItemIcon>
            <SvgIcon fontSize="small">
              <SettingsOutlinedIcon />
            </SvgIcon>
          </ListItemIcon>
          <ListItemText
            primary={<Typography variant="body1">Cấu hình</Typography>}
          />
        </ListItemButton>
      </Box>
      <Divider sx={{ my: '0 !important' }} />
      <Box
        sx={{
          display: 'flex',
          p: 1,
          justifyContent: 'center',
        }}
      >
        <Button color="inherit" onClick={handleLogout} size="small">
          Đăng xuất
        </Button>
      </Box>
    </Popover>
  );
};

AccountPopover.propTypes = {
  anchorEl: PropTypes.any,
  onClose: PropTypes.func,
  open: PropTypes.bool,
};
